import EmployeeListActionTypes from './employeelist.types';

export const employeeListStart = (employeelistData: any) => ({
	type: EmployeeListActionTypes.EMPLOYEELIST_START,
	payload: employeelistData,
});

export const employeelistSuccess = (employeelistData: any) => ({
	type: EmployeeListActionTypes.EMPLOYEELIST_SUCCESS,
	payload: employeelistData,
});

export const employeelistFailure = (error: any) => ({
	type: EmployeeListActionTypes.EMPLOYEELIST_FAILURE,
	payload: error,
});

export const employeelistResponseChanged = (response: any) => ({
	type: EmployeeListActionTypes.EMPLOYEELIST_RESPONSE_CHANGED,
	payload: response,
});

export const employeelistResponseRestStart = () => ({
	type: EmployeeListActionTypes.EMPLOYEELIST_RESPONSE_REST_START,
});

export const getAllEmployeeListStart = (organisationID: any) => ({
	type: EmployeeListActionTypes.GET_ALL_EMPLOYEE_LIST_START,
	payload: organisationID,
});

export const getAllEmployeeListSuccess = (employeelistData: any) => ({
	type: EmployeeListActionTypes.GET_ALL_EMPLOYEE_LIST_SUCCESS,
	payload: employeelistData,
});

export const getAllEmployeeListFailure = (error: any) => ({
	type: EmployeeListActionTypes.GET_ALL_EMPLOYEE_LIST_FAILURE,
	payload: error,
});

export const getAllEmployeeListResponseChanged = (response: any) => ({
	type: EmployeeListActionTypes.GET_ALL_EMPLOYEE_LIST_RESPONSE_CHANGED,
	payload: response,
});

export const getAllEmployeeListResponseRestStart = () => ({
	type: EmployeeListActionTypes.GET_ALL_EMPLOYEE_LIST_RESPONSE_REST_START,
});

export const getAllEmployeeListResponseRestSuccess = (employeelistData: any) => ({
	type: EmployeeListActionTypes.GET_ALL_EMPLOYEE_LIST_RESPONSE_REST_SUCCESS,
	payload: employeelistData,
});

export const getAllEmployeeListResponseRestFailure = (error: any) => ({
	type: EmployeeListActionTypes.GET_ALL_EMPLOYEE_LIST_RESPONSE_REST_FAILURE,
	payload: error,
});

export const getEmployeeByIDStart = (employeeID: any) => ({
	type: EmployeeListActionTypes.GET_EMPLOYEE_BY_ID_START,
	payload: employeeID,
});

export const getEmployeeByIDSuccess = (employeelistData: any) => ({
	type: EmployeeListActionTypes.GET_EMPLOYEE_BY_ID_SUCCESS,
	payload: employeelistData,
});

export const getEmployeeByIDFailure = (error: any) => ({
	type: EmployeeListActionTypes.GET_EMPLOYEE_BY_ID_FAILURE,
	payload: error,
});

export const getEmployeeByIDResponseChanged = (response: any) => ({
	type: EmployeeListActionTypes.GET_EMPLOYEE_BY_ID_RESPONSE_CHANGED,
	payload: response,
});

export const getEmployeeByIDResponseRestStart = () => ({
	type: EmployeeListActionTypes.GET_EMPLOYEE_BY_ID_RESPONSE_REST_START,
});

export const getEmployeeByIDResponseRestSuccess = (employeelistData: any) => ({
	type: EmployeeListActionTypes.GET_EMPLOYEE_BY_ID_RESPONSE_REST_SUCCESS,
	payload: employeelistData,
});

export const getEmployeeByIDResponseRestFailure = (error: any) => ({
	type: EmployeeListActionTypes.GET_EMPLOYEE_BY_ID_RESPONSE_REST_FAILURE,
	payload: error,
});

export const updateEmployeeStart = (employeeData: any) => ({
	type: EmployeeListActionTypes.UPDATE_EMPLOYEE_START,
	payload: employeeData,
});

export const updateEmployeeSuccess = (response: any) => ({
	type: EmployeeListActionTypes.UPDATE_EMPLOYEE_SUCCESS,
	payload: response,
});

export const updateEmployeeFailure = (error: any) => ({
	type: EmployeeListActionTypes.UPDATE_EMPLOYEE_FAILURE,
	payload: error,
});

export const updateEmployeeResponseRestStart = () => ({
	type: EmployeeListActionTypes.UPDATE_EMPLOYEE_RESPONSE_REST_START,
});
